import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface GeoLoc {
  lon: number;
  lat: number;
}

@Injectable({
  providedIn: 'root',
})
export class GeoLocService {
  geoLoc$: BehaviorSubject<GeoLoc | undefined> = new BehaviorSubject<
    GeoLoc | undefined
  >(undefined);

  set geoLoc(value: GeoLoc | undefined) {
    this.geoLoc$.next(value);
  }
}
